import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import "./MyProfile.scss";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ContactDataAccordion from "components/ContactDataAccordion/ContactDataAccordion";

export type IProps = {
  disabledEdit?: boolean;
};

const MyProfile = ({
  disabledEdit = true
}: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleBack = () => {
    dispatch(push("/"));
  };
  return (
    <div className="profile-container">
      <div className="profile-content">
        <button id="profile-go-back" className="profile-go-back" onClick={handleBack}>
          <div className="profile-content-button">
            <FontAwesomeIcon
              className="profile-content-button__icon"
              icon={faChevronLeft}
            />
            <p>Volver</p>
          </div>
        </button>
        <div className="profile">
          <div className="title-info">
            <p className="title-profile">{t("header.profile")}</p>
            <p className="description-subtitle">{t("myProfile.subtitle")}</p>
          </div>
          <ContactDataAccordion />
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
